/* eslint-disable react/button-has-type */
import { useRef, useState } from "react";
import { animated, useSpring } from "@react-spring/web";
import classNames from "classnames";

// Constants
import { GAME_SORT } from "constants/games";

// Hooks
import useTranslate from "hooks/useTranslate";
import useClickOutside from "hooks/useClickOutside";

// Icons
import Rows from "assets/icons/glory/sort-provider.svg?react";
import ArrowDown from "assets/icons/arrowDown.svg?react";

import "./styles.sass";

type GameSortDesktopProps = {
  selected: string;
  onSelect: (option: string) => void;
};

const GameSortDesktop = (props: GameSortDesktopProps) => {
  const { selected, onSelect } = props;

  const [isOpen, setIsOpen] = useState(false);

  const sortRef = useRef(null);

  const [spring, api] = useSpring(() => ({
    height: 0,
  }));

  const t = useTranslate();

  const open = () => {
    api.start({ height: 176 });
    setIsOpen(true);
  };
  const close = () => {
    api.start({ height: 0 });
    setTimeout(() => {
      setIsOpen(false);
    }, 200);
  };

  useClickOutside({ refs: [sortRef], handler: close });

  const handleClick = () => {
    if (isOpen) {
      close();
    } else {
      open();
    }
  };

  const handleSelect = (option: string) => {
    close();
    onSelect(option);
  };

  const btnClass = classNames("GameSortDesktop__btn", { active: isOpen });

  return (
    <div className="GameSortDesktop" ref={sortRef}>
      <button className={btnClass} onClick={handleClick}>
        <div className="GameSortDesktop__icon">
          <Rows />
        </div>
        <span className="GameSortDesktop__title">{t("sort.title")}</span>
        <div className="GameSortDesktop__arrow">
          <ArrowDown />
        </div>
      </button>
      {isOpen && (
        <animated.div
          className="GameSortDesktop__content"
          style={{ ...spring }}
        >
          {GAME_SORT.map((sort) => {
            const itemClass = classNames("GameSortDesktop__item", {
              active: selected === sort.option,
            });
            return (
              <div
                key={sort.id}
                className={itemClass}
                onClick={() => handleSelect(sort.option)}
              >
                {t(sort.title)}
              </div>
            );
          })}
        </animated.div>
      )}
    </div>
  );
};

export default GameSortDesktop;
